import { cn } from '../../lib/cn';
import type { TaskFlowPhase } from '../../hx/framework';
import { TASK_FLOW_PHASES } from '../../hx/framework';

type Props = {
  activePhase?: TaskFlowPhase;
  className?: string;
};

export function TaskFlowStepper({ activePhase = 'recommendations', className }: Props) {
  const activeIdx = TASK_FLOW_PHASES.findIndex((p) => p.id === activePhase);

  return (
    <div className={cn('overflow-x-auto', className)}>
      <div className="flex min-w-max items-center gap-1">
        {TASK_FLOW_PHASES.map((phase, i) => {
          const isActive = phase.id === activePhase;
          const isPast = i < activeIdx;
          return (
            <div key={phase.id} className="flex items-center">
              {i > 0 && (
                <div className={cn('mx-1 h-px w-4', isPast ? 'bg-brand-400' : 'bg-slate-200 dark:bg-slate-700')} />
              )}
              <div
                className={cn(
                  'rounded-full px-2.5 py-1 text-xs font-medium whitespace-nowrap',
                  isActive && 'bg-brand-600 text-white',
                  isPast && !isActive && 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
                  !isActive && !isPast && 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
                )}
              >
                {phase.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
